import styled, { css } from 'styled-components';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { Typography } from '../../../global/theme';
import { AlignCenter, FlexBetween } from '../../../global/commonStyle';

const BottomSection = styled.div`
  width: 100%;
  padding-top: var(--space-12);
  border-top: 0.5px solid var(--border-primary);
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
  ${mobile_xl(css`
    gap: var(--space-16);
    padding-top: var(--space-16);
  `)}
`;

const BottomSubSections = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
  padding-bottom: var(--space-12);
  border-bottom: 0.5px solid var(--border-primary);
  &:last-child {
    padding-bottom: var(--space-0);
    border-bottom: none;
  }
  ${mobile_xl(css`
    gap: var(--space-20);
    padding-bottom: var(--space-16);
  `)}
`;
const Data = styled.div`
  width: 100%;
  ${FlexBetween}
  padding: var(--space-0);
  gap: var(--space-20);
  .dropdown-icon {
    transform: rotate(180deg);
  }
  ${mobile_xl(css`
    gap: var(--space-10);
  `)}
`;
const DropText = styled.p`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  margin: var(--space-0);
`;

const GroupDiv = styled.div`
  ${AlignCenter}
  gap: var(--space-6);
  svg {
    stroke: var(--text-secondary);
  }
`;

const ChipSection = styled.div`
  ${AlignCenter}
  flex-wrap: wrap;
  gap: var(--space-6);
`;

const PropertiesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
`;

export { BottomSection, BottomSubSections, Data, DropText, GroupDiv, ChipSection, PropertiesSection };
